export const formContentStyle = {
	form: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		gap: '16px',
		marginBottom: '40px',
	},

	passwordIcon: {
		'& svg path': {
			fill: 'var(--neutral-200)',
		},

		'& .Mui-error svg path': {
			fill: 'var(--error-500)',
		},
	},

	checkbox: {
		marginBottom: '8px',
	},

	privacy: {
		display: 'flex',
		width: '100%',
		fontSize: '14px',
		color: 'var(--neutral-500)',
	},
};
